export default __webpack_public_path__ + "static/media/vodafone-light.0f6868ad.woff";